import { memo } from 'react';

import styles from './thinking-indicator.module.scss';

export type ThinkingIndicatorProps = {
  text: string;
};

export const ThinkingIndicator = memo(({ text }: ThinkingIndicatorProps) => (
  <div className={styles.message}>
    <div className={styles.message__container}>
      <div className={styles.message__content}>
        <div className={styles.message__text}>
          <span className={styles.typingText}>
            {text}
            <span className={styles.cursorDots} />
          </span>
        </div>
      </div>
    </div>
  </div>
));
